const getAuthToken = () =>{
  const cookie = localStorage.getItem('authToken')
  const authToken = cookie? JSON.parse(cookie) :null
  if(authToken) return authToken.token
  else return false
}


export default getAuthToken